webpackJsonp([7,17],{

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(239),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(315),
  /* template */
  __webpack_require__(318),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 203:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(216)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(219),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDlDMTYuNTUyMyA5IDE3IDguNTUyMjggMTcgOEMxNyA3LjQ0NzcyIDE2LjU1MjMgNyAxNiA3TDE2IDlaTTAuMjkyODkzIDcuMjkyODlDLTAuMDk3NjMxIDcuNjgzNDIgLTAuMDk3NjMxMSA4LjMxNjU4IDAuMjkyODkzIDguNzA3MTFMNi42NTY4NSAxNS4wNzExQzcuMDQ3MzggMTUuNDYxNiA3LjY4MDU0IDE1LjQ2MTYgOC4wNzEwNyAxNS4wNzExQzguNDYxNTkgMTQuNjgwNSA4LjQ2MTU5IDE0LjA0NzQgOC4wNzEwNyAxMy42NTY5TDIuNDE0MjEgOEw4LjA3MTA3IDIuMzQzMTVDOC40NjE1OSAxLjk1MjYyIDguNDYxNTkgMS4zMTk0NiA4LjA3MTA3IDAuOTI4OTMxQzcuNjgwNTQgMC41Mzg0MDcgNy4wNDczOCAwLjUzODQwNyA2LjY1Njg1IDAuOTI4OTMxTDAuMjkyODkzIDcuMjkyODlaTTE2IDdMMSA3TDEgOUwxNiA5TDE2IDdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");

/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEgN0MwLjQ0NzcxNSA3IDAgNy40NDc3MiAwIDhDMCA4LjU1MjI4IDAuNDQ3NzE1IDkgMSA5VjdaTTE2LjcwNzEgOC43MDcxMUMxNy4wOTc2IDguMzE2NTggMTcuMDk3NiA3LjY4MzQyIDE2LjcwNzEgNy4yOTI4OUwxMC4zNDMxIDAuOTI4OTMyQzkuOTUyNjIgMC41Mzg0MDggOS4zMTk0NiAwLjUzODQwOCA4LjkyODkzIDAuOTI4OTMyQzguNTM4NDEgMS4zMTk0NiA4LjUzODQxIDEuOTUyNjIgOC45Mjg5MyAyLjM0MzE1TDE0LjU4NTggOEw4LjkyODkzIDEzLjY1NjlDOC41Mzg0MSAxNC4wNDc0IDguNTM4NDEgMTQuNjgwNSA4LjkyODkzIDE1LjA3MTFDOS4zMTk0NiAxNS40NjE2IDkuOTUyNjIgMTUuNDYxNiAxMC4zNDMxIDE1LjA3MTFMMTYuNzA3MSA4LjcwNzExWk0xIDlIMTZWN0gxVjlaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(229)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-40a2ff84",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiByeD0iMzAiIGZpbGw9IiM1NTU1RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMS40MjM4IDE3LjU2ODFDMzEuNzc1MiAxNy43MzI2IDMxLjk5OTcgMTguMDg1NiAzMS45OTk3IDE4LjQ3MzZWNDIuMTU3OUMzMS45OTk3IDQyLjU0NTkgMzEuNzc1MiA0Mi44OTg5IDMxLjQyMzggNDMuMDYzNEMzMS4wNzI1IDQzLjIyOCAzMC42NTc2IDQzLjE3NDUgMzAuMzU5NSA0Mi45MjYxTDIyLjc0MjkgMzYuNTc4OUgyMC40NzM0QzE4LjQ2NzcgMzYuNTc4OSAxNi44NDE4IDM0Ljk1MyAxNi44NDE4IDMyLjk0NzNWMjcuNjg0MkMxNi44NDE4IDI1LjY3ODUgMTguNDY3NyAyNC4wNTI2IDIwLjQ3MzQgMjQuMDUyNkgyMi43NDI5TDMwLjM1OTUgMTcuNzA1NEMzMC42NTc2IDE3LjQ1NyAzMS4wNzI1IDE3LjQwMzUgMzEuNDIzOCAxNy41NjgxWk0zOC4xODczIDIxLjcxMzlDMzguNTc3OCAyMS4zMjM0IDM5LjIxMSAyMS4zMjM0IDM5LjYwMTUgMjEuNzEzOUM0MS44NTc0IDIzLjk2OTggNDIuNTI2IDI3LjU5MjQgNDIuNTI2IDMwLjMxNThDNDIuNTI2IDMzLjAzOTEgNDEuODU3NCAzNi42NjE3IDM5LjYwMTUgMzguOTE3NkMzOS4yMTEgMzkuMzA4MSAzOC41Nzc4IDM5LjMwODEgMzguMTg3MyAzOC45MTc2QzM3Ljc5NjggMzguNTI3MSAzNy43OTY4IDM3Ljg5MzkgMzguMTg3MyAzNy41MDM0QzM5Ljg3ODggMzUuODExOSA0MC41MjYgMzIuODU1NSA0MC41MjYgMzAuMzE1OEM0MC41MjYgMjcuNzc2IDM5Ljg3ODggMjQuODE5NiAzOC4xODczIDIzLjEyODFDMzcuNzk2OCAyMi43Mzc2IDM3Ljc5NjggMjIuMTA0NCAzOC4xODczIDIxLjcxMzlaTTM0LjI0IDI1LjY2MTJDMzQuNjMwNSAyNS4yNzA3IDM1LjI2MzcgMjUuMjcwNyAzNS42NTQyIDI1LjY2MTNDMzYuNTMyOCAyNi41Mzk5IDM3LjI2MjggMjguMTI3OCAzNy4yNjI4IDMwLjMxNThDMzcuMjYyOCAzMi41MDM3IDM2LjUzMjggMzQuMDkxNiAzNS42NTQyIDM0Ljk3MDJDMzUuMjYzNiAzNS4zNjA3IDM0LjYzMDUgMzUuMzYwNyAzNC4yNCAzNC45NzAyQzMzLjg0OTQgMzQuNTc5NyAzMy44NDk0IDMzLjk0NjUgMzQuMjQgMzMuNTU2QzM0LjY3NzEgMzMuMTE4OSAzNS4yNjI4IDMyLjA3NTIgMzUuMjYyOCAzMC4zMTU4QzM1LjI2MjggMjguNTU2MyAzNC42NzcxIDI3LjUxMjYgMzQuMjM5OSAyNy4wNzU1QzMzLjg0OTQgMjYuNjg0OSAzMy44NDk0IDI2LjA1MTggMzQuMjQgMjUuNjYxMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return settingsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);




var getSettings = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var settings;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!window.localStorage.engsettings) {
              _context.next = 6;
              break;
            }

            settings = JSON.parse(window.localStorage.engsettings);

            console.log("GOT SETTINGS FROM LOCALSTORAGE");

            return _context.abrupt("return", settings);

          case 6:
            console.log("WAS MADE");
            window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([true, true]));

          case 8:
            return _context.abrupt("return", [true, true]);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getSettings() {
    return _ref.apply(this, arguments);
  };
}();

var setSettings = function () {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(newsetting) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (window.localStorage.engsettings) {
              window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newsetting));
            } else {
              window.localStorage.setItem("engsettings", __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()([true, true]));
            }

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function setSettings(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var settingsService = {
  getSettings: getSettings,
  setSettings: setSettings
};

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(220)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(222),
  /* template */
  __webpack_require__(223),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-245f8eaa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(236),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMzQiIHZpZXdCb3g9IjAgMCAzNCAzNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMyLjY4OTIgMTMuODY3OUMzMi41OTY0IDEzLjM5OTcgMzIuMTg1NiAxMy4wNjIzIDMxLjcwODMgMTMuMDYyM0gzMC44NDgxQzMwLjczOTcgMTMuMDIyIDMwLjYyMjQgMTMgMzAuNSAxM0gxN0MxNi40NDc3IDEzIDE2IDEzLjQ0NzcgMTYgMTRWMjBDMTYgMjAuNTUyMyAxNi40NDc3IDIxIDE3IDIxSDIzLjkxOTFDMjIuNTM2MSAyMy4zOTE1IDE5Ljk1NyAyNSAxNyAyNUMxMi41ODIgMjUgOSAyMS40MTggOSAxN0M5IDEyLjU4MiAxMi41ODIgOSAxNyA5QzE5LjAzNzEgOSAyMC44OTA3IDkuNzY3MyAyMi4zMDYxIDExLjAyNjRDMjIuNzAxOCAxMS4zNzg0IDIzLjMwMzQgMTEuMzYwOSAyMy42Nzc5IDEwLjk4NjRMMjcuOTIwNiA2Ljc0MzYxQzI4LjExMjUgNi41NTE3NSAyOC4yMTgxIDYuMjkwMTggMjguMjEzMyA2LjAxODlDMjguMjA4NiA1Ljc0NzYyIDI4LjA5MzggNS40ODk5MyAyNy44OTUzIDUuMzA0OTVDMjUuMDQwNyAyLjY0NDU2IDIxLjIxNjggMSAxNyAxQzguMTYzOTcgMSAxIDguMTYzOTcgMSAxN0MxIDI1LjgzNiA4LjE2Mzk3IDMzIDE3IDMzQzI1LjgzNiAzMyAzMyAyNS44MzYgMzMgMTdDMzMgMTUuOTI1NCAzMi44ODk0IDE0Ljg3ODYgMzIuNjg5MiAxMy44Njc5WiIgZmlsbD0iI0ZCQkIwMSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yLjg0NDkxIDkuNTUxODdDMi42MTM4MiA5Ljk5MDE4IDIuNzM4NTUgMTAuNTMxNiAzLjEzODExIDEwLjgyNDZMOC4wNjYzNiAxNC40Mzg5QzguMzE1MjMgMTQuNjIxNCA4LjYzNDQzIDE0LjY3ODggOC45MzEyOSAxNC41OTQ0QzkuMjI4MTQgMTQuNTA5OSA5LjQ2OTM4IDE0LjI5MzIgOS41ODQ5NiAxNC4wMDdDMTAuNzcxNCAxMS4wNjk2IDEzLjY0MzMgOSAxNyA5QzE5LjAzNzEgOSAyMC44OTA3IDkuNzY3MyAyMi4zMDYxIDExLjAyNjRDMjIuNzAxOCAxMS4zNzg0IDIzLjMwMzQgMTEuMzYwOSAyMy42Nzc5IDEwLjk4NjRMMjcuOTIwNiA2Ljc0MzYxQzI4LjExMjUgNi41NTE3NSAyOC4yMTgxIDYuMjkwMTggMjguMjEzMyA2LjAxODlDMjguMjA4NiA1Ljc0NzYyIDI4LjA5MzggNS40ODk5MyAyNy44OTUzIDUuMzA0OTVDMjUuMDQwNyAyLjY0NDU2IDIxLjIxNjggMSAxNyAxQzEwLjg1MiAxIDUuNTIzMSA0LjQ3MjExIDIuODQ0OTEgOS41NTE4N1oiIGZpbGw9IiNFQjQ1MzQiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjcuNzI4MSAyOC44NDcxQzI3Ljk0MTcgMjguNjUzNiAyOC4wNjE1IDI4LjM3NzMgMjguMDU2NiAyOC4wODkxQzI4LjA1MTcgMjcuODAwOSAyNy45MjI3IDI3LjUyODkgMjcuNzAyNyAyNy4zNDI3TDIzLjA2MDIgMjMuNDE0MkMyMi43MDI5IDIzLjExMTggMjIuMTgzNiAyMy4wOTc3IDIxLjgxMDQgMjMuMzgwNEMyMC40NzA0IDI0LjM5NTQgMTguODA4NiAyNSAxNyAyNUMxMy41MzU2IDI1IDEwLjU4OTMgMjIuNzkxNiA5LjQ3ODc5IDE5LjcwMjJDOS4zNzA2NyAxOS40MDE1IDkuMTI1MjkgMTkuMTcwNSA4LjgxODUzIDE5LjA4MDhDOC41MTE3NyAxOC45OTEgOC4xODA2IDE5LjA1MzMgNy45Mjc0MSAxOS4yNDg0TDMuMDM1OTEgMjMuMDE3MUMyLjY1NDMzIDIzLjMxMTEgMi41MzY1NyAyMy44MzU0IDIuNzU1NzggMjQuMjY0M0M1LjQwMTcgMjkuNDQxOSAxMC43Nzg0IDMzIDE3IDMzQzIxLjEzNTQgMzMgMjQuODkyMSAzMS40MTYyIDI3LjcyODEgMjguODQ3MVoiIGZpbGw9IiM0Q0FGNTAiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzIuNjg5MiAxMy44Njc5QzMyLjU5NjQgMTMuMzk5NyAzMi4xODU2IDEzLjA2MjMgMzEuNzA4MyAxMy4wNjIzSDMwLjg0ODFDMzAuNzM5NyAxMy4wMjIgMzAuNjIyNCAxMyAzMC41IDEzSDE3QzE2LjQ0NzcgMTMgMTYgMTMuNDQ3NyAxNiAxNFYyMEMxNiAyMC41NTIzIDE2LjQ0NzcgMjEgMTcgMjFIMjMuOTE3NkMyMy4zNzk4IDIxLjkyNjUgMjIuNjYwNCAyMi43MzYgMjEuODA4NCAyMy4zODA5QzIxLjM3NzQgMjMuNzA3MiAyMS4yODM3IDI0LjMxNjkgMjEuNTk2OSAyNC43NTc1QzIxLjY2MTcgMjQuODQ4OCAyMS43MzkyIDI0LjkyNiAyMS44MjUyIDI0Ljk4ODNMMjYuMzY4NiAyOC44MzNDMjYuNDE1OCAyOC44ODYgMjYuNDYyMiAyOC45MzE3IDI2LjUwMjkgMjguOTYzMkMyNi42MzA0IDI5LjAzMjQgMjYuODY3MSAyOS4xMDU3IDI2Ljk2OTcgMjkuMTE4NUMyNy4xNTk2IDI5LjEzMjQgMjcuMzA0NCAyOS4wODcxIDI3LjM0MDcgMjkuMDc1OEwyNy4zNDE0IDI5LjA3NTVDMjcuNDM3MSAyOS4wNDU2IDI3LjUwNzUgMjkuMDA3MSAyNy41MjM4IDI4Ljk5ODNMMjcuNTI1MSAyOC45OTc2QzI3LjU3MjQgMjguOTcxOCAyNy42MDkyIDI4Ljk0NjcgMjcuNjIxNiAyOC45MzgzQzI3LjY4MDUgMjguODk4MSAyNy43NDgzIDI4Ljg0NDYgMjcuODEwNiAyOC43OTMzQzI3Ljk0NzggMjguNjgwMiAyOC4xNDg4IDI4LjUwMjkgMjguMzkyMiAyOC4yNjMyQzI4Ljg3OTcgMjcuNzgzMSAyOS41NTE2IDI3LjAzOTIgMzAuMjMxOSAyNi4wMzk3QzMxLjU5MzcgMjQuMDM4OCAzMyAyMC45OTUyIDMzIDE3QzMzIDE1LjkyNTQgMzIuODg5NCAxNC44Nzg2IDMyLjY4OTIgMTMuODY3OVpNMjcuNzI5MyAyOC44NDUzQzI3LjczMDIgMjguODQ0NSAyNy43MzEyIDI4Ljg0MzYgMjcuNzMyMiAyOC44NDI3QzI3LjczMDggMjguODQzOSAyNy43Mjk5IDI4Ljg0NDcgMjcuNzI5NSAyOC44NDUxTDI3LjcyOTMgMjguODQ1M1oiIGZpbGw9IiM0Mjg2RjUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzEuNzA4MyAxNC4wNjIzSDMwLjVWMTRIMTdWMjBIMjUuNDc3M0MyNC4yNDA1IDIzLjQ5MjggMjAuOTE3MiAyNiAxNyAyNkMxMi4wMjk3IDI2IDggMjEuOTcwMiA4IDE3QzggMTIuMDI5NyAxMi4wMjk3IDggMTcgOEMxOS4yOTQzIDggMjEuMzgxNSA4Ljg2NTUgMjIuOTcwOCAxMC4yNzkyTDI3LjIxMzUgNi4wMzY1QzI0LjUzNDUgMy41Mzk3NSAyMC45NTEgMiAxNyAyQzguNzE2MjUgMiAyIDguNzE2MjUgMiAxN0MyIDI1LjI4MzggOC43MTYyNSAzMiAxNyAzMkMyNS4yODM4IDMyIDMyIDI1LjI4MzggMzIgMTdDMzIgMTUuOTk0MyAzMS44OTY1IDE1LjAxMjUgMzEuNzA4MyAxNC4wNjIzWiIgZmlsbD0iI0ZCQkIwMSIvPgo8cGF0aCBkPSJNMy43Mjk0OSAxMC4wMTgyTDguNjU3NzQgMTMuNjMyNUM5Ljk5MTI0IDEwLjMzMSAxMy4yMjA3IDggMTcgOEMxOS4yOTQyIDggMjEuMzgxNSA4Ljg2NTUgMjIuOTcwNyAxMC4yNzkyTDI3LjIxMzUgNi4wMzY1QzI0LjUzNDUgMy41Mzk3NSAyMC45NTEgMiAxNyAyQzExLjIzODUgMiA2LjI0MTk5IDUuMjUyNzUgMy43Mjk0OSAxMC4wMTgyWiIgZmlsbD0iI0VCNDUzNCIvPgo8cGF0aCBkPSJNMTcgMzJDMjAuODc0NSAzMiAyNC4zOTUgMzAuNTE3MyAyNy4wNTY3IDI4LjEwNkwyMi40MTQyIDI0LjE3NzVDMjAuOTA4MiAyNS4zMTgzIDE5LjAzNjIgMjYgMTcgMjZDMTMuMDk4NSAyNiA5Ljc4NTc0IDIzLjUxMjMgOC41Mzc3NCAyMC4wNDA1TDMuNjQ2MjQgMjMuODA5M0M2LjEyODc0IDI4LjY2NyAxMS4xNzAyIDMyIDE3IDMyWiIgZmlsbD0iIzRDQUY1MCIvPgo8cGF0aCBkPSJNMzEuNzA4MyAxNC4wNjIzSDMwLjVWMTRIMTdWMjBIMjUuNDc3M0MyNC44ODMzIDIxLjY3NzggMjMuODA0IDIzLjEyNDUgMjIuNDEyIDI0LjE3ODJMMjIuNDE0MiAyNC4xNzY4TDI3LjA1NjggMjguMTA1MkMyNi43MjgzIDI4LjQwMzcgMzIgMjQuNSAzMiAxN0MzMiAxNS45OTQzIDMxLjg5NjUgMTUuMDEyNSAzMS43MDgzIDE0LjA2MjNaIiBmaWxsPSIjNDI4NkY1Ii8+Cjwvc3ZnPgo=");

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArrowIconPath; });
var getArrowIconPath = function getArrowIconPath(languageDirection) {

    var arrowIconNext = void 0;
    var arrowIconPrevious = void 0;

    if (languageDirection === 'rtl') {
        arrowIconNext = __webpack_require__(205).default;
        arrowIconPrevious = __webpack_require__(206).default;
    } else {
        arrowIconNext = __webpack_require__(206).default;
        arrowIconPrevious = __webpack_require__(205).default;
    }

    return {
        arrowIconNext: arrowIconNext,
        arrowIconPrevious: arrowIconPrevious
    };
};

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(217);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("f5ffd5f0", content, true, {});

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.VideoPlayer iframe {\n  width: 100%;\n  max-height: 600px;\n  max-width: 800px;\n  /* height: 100%; */\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/VideoPlayer.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;CACpB","file":"VideoPlayer.vue","sourcesContent":["\n.VideoPlayer iframe {\n  width: 100%;\n  max-height: 600px;\n  max-width: 800px;\n  /* height: 100%; */\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    vidSrc: {
      default: ""
    }
  },
  data: function data() {
    return {
      height: "250px"
    };
  },
  mounted: function mounted() {
    // setTimeout(() => {
    //   this.height = (this.$refs.videoIframe.clientWidth / 16) * 9 + "px";
    //   console.log(this.height);
    // }, 2000);
  }
});

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "VideoPlayer"
  }, [_c('iframe', {
    ref: "videoIframe",
    attrs: {
      "src": _vm.vidSrc,
      "height": _vm.height,
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": ""
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(221);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("7be071af", content, true, {});

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n@-webkit-keyframes spin {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n@keyframes spin-data-v-245f8eaa {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n.slinky-loader[data-v-245f8eaa] {\n  position: relative;\n  margin-top: 20px;\n  width: 40px;\n  aspect-ratio: 1;\n  border: 5px solid #555fff;\n  -webkit-animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n          animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n  border-radius: 50%;\n}\n.slinky-loader[data-v-245f8eaa]::after {\n  position: absolute;\n  content: \"\";\n  width: 30%;\n  aspect-ratio: 1;\n  top: 50%;\n  left: 100%;\n  -webkit-transform: translate(-25%, -50%);\n          transform: translate(-25%, -50%);\n  background: white;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/Slinky.vue"],"names":[],"mappings":";AACA;AACA;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;AACA;IACI,kCAAkC;YAC1B,0BAA0B;CACrC;CACA;AACD;EACE,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,sEAAsE;UAC9D,8DAA8D;EACtE,mBAAmB;CACpB;AACD;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,WAAW;EACX,yCAAyC;UACjC,iCAAiC;EACzC,kBAAkB;CACnB","file":"Slinky.vue","sourcesContent":["\n@-webkit-keyframes spin {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n@keyframes spin-data-v-245f8eaa {\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n.slinky-loader[data-v-245f8eaa] {\n  position: relative;\n  margin-top: 20px;\n  width: 40px;\n  aspect-ratio: 1;\n  border: 5px solid #555fff;\n  -webkit-animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n          animation: spin-data-v-245f8eaa infinite 0.8s linear forwards;\n  border-radius: 50%;\n}\n.slinky-loader[data-v-245f8eaa]::after {\n  position: absolute;\n  content: \"\";\n  width: 30%;\n  aspect-ratio: 1;\n  top: 50%;\n  left: 100%;\n  -webkit-transform: translate(-25%, -50%);\n          transform: translate(-25%, -50%);\n  background: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Slinky"
});

/***/ }),

/***/ 223:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slinky-loader"
  })
},staticRenderFns: []}

/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(228);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("341b2bf2", content, true, {});

/***/ }),

/***/ 227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTcuNDEgOC41OUwxMiAxMy4xN2w0LjU5LTQuNThMMTggMTBsLTYgNi02LTYgMS40MS0xLjQxeiIvPjwvc3ZnPg==");

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "#progressBar{position:relative;top:-7px}.slider::-moz-range-thumb{width:20px;height:20px;border-radius:50%;background:#555fff;cursor:pointer}.slider::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:20px;height:20px;background:#555fff;border-radius:50%;cursor:pointer}.disabledBtn{display:none}.audio-player-container{display:flex;align-items:center;justify-content:center;gap:8px}.speed-btn{background:var(--bg-primary, #555fff);color:#fff;border:none;border-radius:16px;padding:4px 8px;font-size:12px;font-weight:500;min-width:36px;height:24px;cursor:pointer;transition:all .2s ease;user-select:none}.speed-btn:hover{background:var(--bg-primary-hover, #4444ee);transform:scale(1.05)}.speed-btn:active{transform:scale(0.95)}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/AudioPlayer.scss"],"names":[],"mappings":"AAAA,aACE,kBAEA,QAAA,CAGF,0BACE,WACA,YACA,kBAEA,mBACA,cAAA,CAGF,8BACE,wBACA,gBACA,WACA,YACA,mBACA,kBACA,cAAA,CA4DF,aACE,YAAA,CAGF,wBACE,aACA,mBACA,uBACA,OAAA,CAGF,WACE,sCACA,WACA,YACA,mBACA,gBACA,eACA,gBACA,eACA,YACA,eACA,wBACA,gBAAA,CAEA,iBACE,4CACA,qBAAA,CAGF,kBACE,qBAAA,CAAA","file":"AudioPlayer.scss","sourcesContent":["#progressBar {\n  position: relative;\n  // top: -9px;\n  top: -7px;\n}\n\n.slider::-moz-range-thumb {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n\n  background: #555fff;\n  cursor: pointer;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 20px;\n  height: 20px;\n  background: #555fff;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n// input[type=\"range\"] {\n//   -webkit-appearance: none;\n//   // margin-right: 15px;\n//   width: 120px;\n//   height: 7px;\n//   background: #aaabbb;\n//   border-radius: 5px;\n//   background-position: right center;\n//   background-image: linear-gradient(#7070af, #111199);\n//   background-size: 0% 100%;\n//   background-repeat: no-repeat;\n// }\n\n// input[type=\"range\"]::-webkit-slider-thumb {\n//   -webkit-appearance: none;\n//   height: 15px;\n//   width: 15px;\n//   border-radius: 50%;\n//   background: #555fff;\n//   cursor: ew-resize;\n//   box-shadow: 0 0 2px 0 #555;\n//   transition: background 0.3s ease-in-out;\n// }\n\n// input[type=\"range\"]::-moz-range-thumb {\n//   -webkit-appearance: none;\n//   height: 15px;\n//   width: 15px;\n//   border-radius: 50%;\n//   background: #555fff;\n//   cursor: ew-resize;\n//   box-shadow: 0 0 2px 0 #390b8d;\n//   transition: background 0.3s ease-in-out;\n// }\n\n// input[type=\"range\"]::-webkit-slider-runnable-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: transparent;\n// }\n\n// input[type=\"range\"]::-moz-range-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: transparent;\n// }\n\n// NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE NOPE\n// .slider::-webkit-slider-runnable-track {\n//   -webkit-appearance: none;\n//   box-shadow: none;\n//   border: none;\n//   background: blue;\n// }\n\n.disabledBtn {\n  display: none;\n}\n\n.audio-player-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.speed-btn {\n  background: var(--bg-primary, #555fff);\n  color: white;\n  border: none;\n  border-radius: 16px;\n  padding: 4px 8px;\n  font-size: 12px;\n  font-weight: 500;\n  min-width: 36px;\n  height: 24px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n  \n  &:hover {\n    background: var(--bg-primary-hover, #4444ee);\n    transform: scale(1.05);\n  }\n  \n  &:active {\n    transform: scale(0.95);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(230);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("2144f390", content, true, {});

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.noaudio[data-v-40a2ff84] {\n  min-width: 40px;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/audioBtn.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;CACjB","file":"audioBtn.vue","sourcesContent":["\n.noaudio[data-v-40a2ff84] {\n  min-width: 40px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audioBtn_scss__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audioBtn_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__audioBtn_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_audioService__ = __webpack_require__(76);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "audio-btn",
  props: {
    urlId: {
      type: String | Number,
      require: true
    },
    height: {
      type: Number,
      default: 50
    },
    autoplay: {
      type: Boolean,
      deafult: false
    },
    idx: {
      type: Number,
      default: 0
    },
    display: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      audioSrc: "",
      isStop: null,
      showError: false
    };
  },
  created: function created() {
    this.getAudio();
  },

  watch: {
    urlId: function urlId() {
      if (this.idx) return;
      this.isStop = true;
      this.getAudio();
    },
    idx: function idx() {
      this.isStop = true;
      this.getAudio();
    },
    autoplay: function autoplay() {
      if (this.autoplay) this.playAudio();
    }
  },
  methods: {
    getAudio: function getAudio() {
      var _this = this;

      console.log(this.autoplay);
      if (this.urlId) {
        __WEBPACK_IMPORTED_MODULE_3__services_audioService__["a" /* audioService */].playAudio(this.urlId).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
            var _ref2, sound_file;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return res.json();

                  case 2:
                    _ref2 = _context.sent;
                    sound_file = _ref2.sound_file;

                    _this.audioSrc = sound_file;
                    if (_this.autoplay && _this.audioSrc) {
                      // this.isStop = false;
                      _this.playAudio();
                    }

                  case 6:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, _this);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } else {
        this.audioSrc = null;
      }
    },
    playAudio: function playAudio(ev) {
      var _this2 = this;

      if (ev) {
        ev.stopPropagation();
      }
      if (this.$store.getters.isPlaying) {
        setTimeout(function () {}, 1500);
      }
      var audio = new Audio(this.audioSrc);
      document.getElementById('speaker-svg').classList.add("is-playing");
      this.$store.commit("setIsPlaying", true);
      audio.play().then(this.$store.commit("setIsPlaying", false)).catch(function (e) {
        console.log(e);
        _this2.$store.commit("setError", e);
        _this2.$store.commit("setIsPlaying", false);
      });
      document.getElementById('speaker-svg').classList.remove("is-playing");
    }
  },
  updated: function updated() {
    console.log("audio is updated");
  },
  destroyed: function destroyed() {
    this.isStop = true;
  },

  components: {}
});

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(233);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("5ddadbf4", content, true, {});

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".audio-btn{cursor:pointer;position:relative}.audio .audio-btn{width:28px !important;aspect-ratio:1/1}.audio .audio-btn svg{width:100%;height:100%}.speaker-svg{width:60px;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}.is-playing{box-shadow:0 0 10px 6px var(--bubble-bg-selected);border-radius:50%}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/components/Shared/audioBtn.scss","/__w/lang_app_eng/lang_app_eng/src/components/Shared/src/scss/abstracts/_mixins.scss"],"names":[],"mappings":"AAGA,WACE,eACA,iBAAA,CAGF,kBACE,sBACA,gBAAA,CAGF,sBACE,WACA,WAAA,CAGF,aACE,WClBA,kBACA,QACA,SACA,+BAAA,CDmBF,YACE,kDACA,iBAAA,CAAA","file":"audioBtn.scss","sourcesContent":["@import \"../../scss/abstracts/variables\";\n@import \"../../scss/abstracts/mixins\";\n\n.audio-btn {\n  cursor: pointer;\n  position: relative;\n}\n\n.audio .audio-btn {\n  width: 28px !important;\n  aspect-ratio: 1/1;\n}\n\n.audio .audio-btn svg {\n  width: 100%;\n  height: 100%;\n}\n\n.speaker-svg {\n  width: 60px;\n  @include absCenter;\n\n}\n.is-playing {\n  box-shadow: 0 0 10px 6px var(--bubble-bg-selected);\n  border-radius: 50%;\n}","@mixin absCenter {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n//media query\n//1em=16px\n// em and rem in media query always equall fs from browser =16px unless user change it.\n//rem failed work with some of browrswers\n@mixin respon($breakpoint) {\n  @if $breakpoint==no-phone {\n    @media (min-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==phone {\n    @media (max-width: 37.5em) {\n      //600px\n      @content;\n    }\n  }\n  @if $breakpoint==700px {\n    @media (max-width: 43.75em) {\n      //700px\n      @content;\n    }\n  }\n  @if $breakpoint==tab-port {\n    @media (max-width: 56.25em) {\n      //900px\n      @content;\n    }\n  }\n\n  @if $breakpoint==tab-land {\n    @media (max-width: 75em) {\n      //1200px\n      @content;\n    }\n  }\n  @if $breakpoint==big-desktop {\n    //1800px\n    @media (min-width: 112.5em) {\n      @content;\n    }\n  }\n}\n\n@mixin aspect-ratio($width, $height) {\n  position: relative;\n  overflow: hidden;\n  &:before {\n    display: block;\n    content: \"\";\n    width: 100%;\n    padding-top: ($height / $width) * 100%;\n  }\n  > * {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n  }\n\n  > img {\n    object-fit: cover;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.audioSrc) ? _c('button', {
    staticClass: "audio-btn",
    style: ({
      height: _vm.height + 'px',
      width: _vm.height + 'px',
      display: _vm.display ? 'inline-block' : 'none'
    }),
    on: {
      "click": _vm.playAudio
    }
  }, [_c('audio', [_c('source', {
    attrs: {
      "src": _vm.audioSrc,
      "type": "audio/mp3"
    }
  })]), _vm._v(" "), _c('inline-svg', {
    staticClass: "speaker-svg",
    attrs: {
      "id": "speaker-svg",
      "src": __webpack_require__(208).default,
      "aria-label": "My image"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.audioSrc) ? _c('div', {
    staticClass: "noaudio"
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    height: { type: String, required: true }
  }
});

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      height: (_vm.height + "px")
    })
  })
},staticRenderFns: []}

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMCAyMiI+PGRlZnM+PHN0eWxlPi5sZXNzb24tY2xzLTF7ZmlsbDojZmY1NTgzO30ubGVzc29uLWNscy0ye2ZpbGw6bm9uZTtzdHJva2U6IzZhMDkyMztzdHJva2Utd2lkdGg6MnB4O30ubGVzc29uLWNscy0ze2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48ZyBpZD0iR3JvdXBfMjQxIiBkYXRhLW5hbWU9Ikdyb3VwIDI0MSI+PGcgaWQ9IlJlY3RhbmdsZV82NzYiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDY3NiI+PHJlY3QgY2xhc3M9Imxlc3Nvbi1jbHMtMSIgd2lkdGg9IjMwIiBoZWlnaHQ9IjIyIiByeD0iNCIvPjxyZWN0IGNsYXNzPSJsZXNzb24tY2xzLTIiIHg9IjEiIHk9IjEiIHdpZHRoPSIyOCIgaGVpZ2h0PSIyMCIgcng9IjMiLz48L2c+PHBhdGggaWQ9IlBvbHlnb25fNTciIGRhdGEtbmFtZT0iUG9seWdvbiA1NyIgY2xhc3M9Imxlc3Nvbi1jbHMtMyIgZD0iTTE2LjE0LDcuMTJhMSwxLDAsMCwxLDEuMzcuMzYsMSwxLDAsMCwxLC4xNC41MWwwLDYuNmExLDEsMCwwLDEtMS41Ljg2bC01LjY3LTMuMjdhMSwxLDAsMCwxLS4zNy0xLjM3LDEsMSwwLDAsMSwuMzYtLjM3WiIvPjwvZz48L2c+PC9nPjwvc3ZnPg==");

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AudioPlayer_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_audioService__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_settingsService__ = __webpack_require__(209);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "AudioPlayer",
  data: function data() {
    return {
      audioFile: null,
      audio: null,
      progressBar: 0,
      isPlaying: null,
      soundSetting: null,
      speakSetting: null,
      playbackRate: 1,
      availableSpeeds: [1, 1.25, 1.5, 2]
    };
  },

  props: {
    urlId: {
      type: String | Number,
      require: false
    },
    hideProgressBar: {
      type: Boolean,
      default: false
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    audioSrc: { type: String, required: true }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_4__services_settingsService__["a" /* settingsService */].getSettings();

            case 2:
              _this.soundSetting = _context.sent;

              _this.loadSavedSpeed();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {
    console.log(this.hideProgressBar);
    if (this.urlId) {
      this.getAudio();
    } else {
      this.audioFile = this.audioSrc;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.audio.pause();
  },

  watch: {
    urlId: function urlId() {
      // this.isStop = true;
      this.getAudio();
    },
    audioFile: function audioFile() {
      this.makeAudio(this.audioFile);
    },
    soundSetting: function soundSetting() {
      if (this.soundSetting && this.soundSetting.length) {
        this.speakSetting = this.soundSetting[1];
      }
      if (this.audio && this.autoPlay && this.speakSetting) this.play();
    },
    audio: function audio() {
      console.log(this.speakSetting);
      if (this.autoPlay && this.speakSetting) this.play();
    },
    progressBar: function progressBar() {
      this.$refs.progressBar.style.backgroundSize = (this.progressBar - 0) * 100 / (100 - 0) + "% 100%";
    },
    $route: function $route(to, from) {
      this.audio.pause();
    }
  },
  methods: {
    getAudio: function getAudio() {
      var _this2 = this;

      if (this.urlId) {
        __WEBPACK_IMPORTED_MODULE_3__services_audioService__["a" /* audioService */].playAudio(this.urlId).then(function () {
          var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
            var _ref2, mediaUrl;

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return res.json();

                  case 2:
                    _ref2 = _context2.sent;
                    mediaUrl = _ref2.mediaUrl;

                    _this2.audioFile = mediaUrl;

                    //this.makeAudio(this.audioFile);
                    // if (this.autoplay) {
                    //   this.isStop = false;
                    //   this.playAudio();
                    // }

                  case 5:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, _this2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      } else {
        this.audioFile = null;
      }
    },
    changeProgress: function changeProgress(e) {
      if (this.audio) this.audio.currentTime = this.audio.duration / 100 * e.target.value;
      var el = e.target;
      console.log((el.value - 0) * 100 / (100 - 0) + "% 100%");
      el.style.backgroundSize = (el.value - 0) * 100 / (100 - 0) + "% 100%";
    },
    play: function play(e) {
      console.log(this.audio.paused);
      if (e) e.stopPropagation();
      if (!this.audio.paused) {
        this.audio.pause();
      } else {
        this.audio.play();
      }
    },
    pause: function pause() {
      this.audio.pause();
    },
    makeAudio: function makeAudio(audioFile) {
      var _this3 = this;

      this.audio = new Audio(audioFile);

      this.audio.volume = 0.5;
      this.audio.playbackRate = this.playbackRate;
      this.audio.addEventListener("timeupdate", function (e) {
        _this3.progressBar = _this3.audio.currentTime / _this3.audio.duration * 100;
      });

      this.audio.addEventListener("ended", function () {
        _this3.audio.currentTime = 0;
        _this3.audio.pause();
      });
    },
    cycleSpeed: function cycleSpeed() {
      var currentIndex = this.availableSpeeds.indexOf(this.playbackRate);
      var nextIndex = (currentIndex + 1) % this.availableSpeeds.length;
      this.playbackRate = this.availableSpeeds[nextIndex];

      if (this.audio) {
        this.audio.playbackRate = this.playbackRate;
      }

      // שמירת המהירות ב-localStorage
      localStorage.setItem('audioPlaybackRate', this.playbackRate);
    },
    loadSavedSpeed: function loadSavedSpeed() {
      var savedRate = localStorage.getItem('audioPlaybackRate');
      if (savedRate && this.availableSpeeds.includes(parseFloat(savedRate))) {
        this.playbackRate = parseFloat(savedRate);
      }
    }
  }
});

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "audio-player-container"
  }, [_c('img', {
    class: {
      disabledBtn: !_vm.audioFile
    },
    attrs: {
      "width": _vm.hideProgressBar ? '50px' : '25px',
      "height": _vm.hideProgressBar ? '50px' : '25px',
      "src": _vm.audio && _vm.audio.paused ?
        __webpack_require__(208).default :
        __webpack_require__(240).default
    },
    on: {
      "click": _vm.play
    }
  }), _vm._v(" "), (!_vm.hideProgressBar && _vm.audioFile) ? _c('button', {
    staticClass: "speed-btn",
    attrs: {
      "title": ("מהירות: " + _vm.playbackRate + "x")
    },
    on: {
      "click": _vm.cycleSpeed
    }
  }, [_vm._v("\n    " + _vm._s(_vm.playbackRate) + "x\n  ")]) : _vm._e(), _vm._v(" "), (!_vm.hideProgressBar) ? _c('input', {
    ref: "progressBar",
    staticClass: "slider",
    attrs: {
      "type": "range",
      "name": "progressBar",
      "id": "progressBar"
    },
    domProps: {
      "value": _vm.progressBar
    },
    on: {
      "input": _vm.changeProgress
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAxNyAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC43MDg5ODQiIHdpZHRoPSI1Ljc3MTgxIiBoZWlnaHQ9IjI1IiByeD0iMi44ODU5MSIgZmlsbD0iIzU1NTVGRiIvPgo8cmVjdCB4PSIxMC4zMjkxIiB3aWR0aD0iNS43NzE4MSIgaGVpZ2h0PSIyNSIgcng9IjIuODg1OTEiIGZpbGw9IiM1NTU1RkYiLz4KPC9zdmc+Cg==");

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,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");

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(256)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(261),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-19b20649",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(257);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("86881e7a", content, true, {});

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.modal[data-v-19b20649] {\n  padding: 0;\n  padding-top: 15px;\n  position: absolute;\n}\n.video-p[data-v-19b20649] {\n  width: 100%;\n  height: 250px;\n}\n.approve[data-v-19b20649] {\n  background: var(--button-primary);\n  color: var(--button-primary-text);\n  padding: 4px;\n  border-radius: 8px;\n  min-height: 60px;\n  width: 100%;\n  font: var(--medium-font);\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/onBoardingModal/OnBoardingModal.vue"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;CACpB;AACD;EACE,YAAY;EACZ,cAAc;CACf;AACD;EACE,kCAAkC;EAClC,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;CAC1B","file":"OnBoardingModal.vue","sourcesContent":["\n.modal[data-v-19b20649] {\n  padding: 0;\n  padding-top: 15px;\n  position: absolute;\n}\n.video-p[data-v-19b20649] {\n  width: 100%;\n  height: 250px;\n}\n.approve[data-v-19b20649] {\n  background: var(--button-primary);\n  color: var(--button-primary-text);\n  padding: 4px;\n  border-radius: 8px;\n  min-height: 60px;\n  width: 100%;\n  font: var(--medium-font);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_AudioPlayer_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Shared_AudioPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Shared_AudioPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_audioBtn_vue__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Shared_audioBtn_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Shared_audioBtn_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Spacer_vue__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Shared_Spacer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Shared_Spacer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_courseService__ = __webpack_require__(77);



var _this2 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      closed: false,
      isAudio: 1,
      lessonImage: null
    };
  },

  props: {
    text: {
      type: String,
      default: ""
    },
    audioSrc: {
      type: String,
      default: ""
    },
    vidSrc: {
      type: String,
      default: ""
    },
    imgSrc: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "lesson"
    },
    id: {
      type: Number,
      default: 0
    }
  },
  watch: {
    audioSrc: function audioSrc() {
      if (this.audioSrc) this.isAudio = 0;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var lesson;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.lessonImage = _this.imgSrc;
              lesson = void 0;

              if (!(_this.type === "lesson")) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_7__services_courseService__["a" /* courseService */].getLessonFromServer(_this.id);

            case 5:
              lesson = _context.sent;

              if (lesson.game) _this.lessonImage = lesson.game.intro_image;

            case 7:
              if (!(_this.type === "game")) {
                _context.next = 13;
                break;
              }

              _context.next = 10;
              return __WEBPACK_IMPORTED_MODULE_7__services_courseService__["a" /* courseService */].getGame(_this.id);

            case 10:
              lesson = _context.sent;

              console.log(lesson);
              _this.lessonImage = lesson.intro_image;

            case 13:
              if (_this.audioSrc) _this.isAudio = 0;

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    closePop: function closePop(e) {
      this.closed = true;
      this.$emit("clicked", this.id);
    },

    makeLinkEmbaddable: function makeLinkEmbaddable(link) {
      if (String(link).includes("shorts")) {
        var _youtubeID = String(link).split("/shorts/")[1];
        return "https://www.youtube.com/embed/" + _youtubeID + "?autoplay=" + _this2.isAudio + "&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
      }
      if (String(link).includes(".be/")) {
        var _youtubeID2 = String(link).split(".be/")[1];
        return "https://www.youtube.com/embed/" + _youtubeID2 + "?autoplay=" + _this2.isAudio + "&fs=1&iv_load_policy=3&showinfo=0&controls=1&playsinline=1&rel=0&cc_load_policy=0&start=0&end=0";
      }
      var youtubeID = String(link).split("watch?v=")[1];
      return "https://www.youtube.com/embed/" + youtubeID + "?autoplay=" + _this2.isAudio + "&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0";
    }
  },

  components: { AudioPlayer: __WEBPACK_IMPORTED_MODULE_3__Shared_AudioPlayer_vue___default.a, VideoPlayer: __WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue___default.a, AudioBtn1: __WEBPACK_IMPORTED_MODULE_5__Shared_audioBtn_vue___default.a, VideoPlayer1: __WEBPACK_IMPORTED_MODULE_4__Shared_VideoPlayer_vue___default.a, Spacer: __WEBPACK_IMPORTED_MODULE_6__Shared_Spacer_vue___default.a }
});

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(260);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("4754144f", content, true, {});

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".blackBG{background-color:var(--color-primary);opacity:.4;position:fixed;top:0;left:0;width:100%;height:100%;z-index:10}.modal{display:flex;flex-direction:column;align-items:center;text-align:center;z-index:1001;background-color:var(--bg-primary);opacity:1;padding:32px 18px !important;border-radius:4px;max-width:calc(100vw - 36px);top:80px;left:50%;margin-top:16px;transform:translate(-50%, 0);justify-content:space-between;gap:24px;max-height:75vh;overflow-y:auto}#img{width:100%;height:auto}.hide{display:none}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/onBoardingModal/src/components/onBoardingModal/style.scss"],"names":[],"mappings":"AAAA,SACE,sCACA,WACA,eACA,MACA,OACA,WACA,YACA,UAAA,CAGF,OACE,aACA,sBACA,mBACA,kBACA,aACA,mCACA,UACA,6BACA,kBACA,6BACA,SACA,SACA,gBACA,6BACA,8BACA,SACA,gBACA,eAAA,CAGF,KACE,WACA,WAAA,CAGF,MACE,YAAA,CAAA","file":"style.scss","sourcesContent":[".blackBG {\n  background-color: var(--color-primary);\n  opacity: 0.4;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n}\n\n.modal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  z-index: 1001;\n  background-color: var(--bg-primary);\n  opacity: 1;\n  padding: 32px 18px !important;\n  border-radius: 4px;\n  max-width: calc(100vw - 36px);\n  top: 80px;\n  left: 50%;\n  margin-top: 16px;\n  transform: translate(-50%, 0);\n  justify-content: space-between;\n  gap: 24px;\n  max-height: 75vh;\n  overflow-y: auto;\n}\n\n#img {\n  width: 100%;\n  height: auto;\n}\n\n.hide {\n  display: none;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.closed) ? _c('div', [_c('div', {
    staticClass: "blackBG"
  }), _vm._v(" "), _c('div', {
    staticClass: "onboarding"
  }, [_c('div', {
    staticClass: "modal"
  }, [(_vm.audioSrc) ? _c('AudioPlayer', {
    attrs: {
      "audioSrc": _vm.audioSrc,
      "autoPlay": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.text) ? _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e(), _vm._v(" "), (_vm.vidSrc) ? _c('VideoPlayer1', {
    staticClass: "video-p",
    attrs: {
      "vidSrc": _vm.makeLinkEmbaddable(_vm.vidSrc)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.imgSrc) ? _c('img', {
    attrs: {
      "id": "img",
      "src": _vm.lessonImage
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "approve",
    on: {
      "click": _vm.closePop
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("OnBoardingModal.OnBoardingModal.start")) + "\n      ")])], 1)])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(286)
}
var Component = __webpack_require__(203)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(291),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-486302e7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgOCA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC41IDMuNUwyIDVMNiAxIiBzdHJva2U9IiMzZjcyMzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIycHgiLz4KPC9zdmc+Cg==");

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMi4yOCAyMi43NSI+PGRlZnM+PHN0eWxlPi53b3Jkcy1jbHMtMXtmaWxsOiM1NTVmZmY7fS53b3Jkcy1jbHMtMiwud29yZHMtY2xzLTN7ZmlsbDpub25lO30ud29yZHMtY2xzLTN7c3Ryb2tlOiMxMTk7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48ZyBpZD0iR3JvdXBfODQiIGRhdGEtbmFtZT0iR3JvdXAgODQiPjxwYXRoIGlkPSJQYXRoXzI1IiBkYXRhLW5hbWU9IlBhdGggMjUiIGNsYXNzPSJ3b3Jkcy1jbHMtMSIgZD0iTTQsMTUuMTJjMS43Ny4wNywxNC4zNCwwLDE0LjM0LDBsLTEuNTcsNi42M0g1LjVaIi8+PHBhdGggaWQ9IlBhdGhfMjYiIGRhdGEtbmFtZT0iUGF0aCAyNiIgY2xhc3M9IndvcmRzLWNscy0xIiBkPSJNMi44MywxMS4yYzIsLjA2LDE2LjQ2LDAsMTYuNDYsMEwxNy40OSwxN0g0LjU4WiIvPjxsaW5lIGlkPSJMaW5lXzE0IiBkYXRhLW5hbWU9IkxpbmUgMTQiIGNsYXNzPSJ3b3Jkcy1jbHMtMiIgeDE9IjMuNTQiIHkxPSIxMS4yIiB4Mj0iMTguNzkiIHkyPSIxMS4yIi8+PGxpbmUgaWQ9IkxpbmVfMTMiIGRhdGEtbmFtZT0iTGluZSAxMyIgY2xhc3M9IndvcmRzLWNscy0yIiB4MT0iMi41MiIgeTE9IjUuODEiIHgyPSIxOS43NCIgeTI9IjUuOCIvPjxwYXRoIGlkPSJQYXRoXzI0IiBkYXRhLW5hbWU9IlBhdGggMjQiIGNsYXNzPSJ3b3Jkcy1jbHMtMyIgZD0iTTEuMTYsMWMxLjM2LjA1LDE0LjEzLDAsMTguODIsMGgxLjE1cy0zLDIwLjcxLTUsMjAuNzFINkM0LjEzLDIxLjc1LDEuMTYsMSwxLjE2LDFaIi8+PC9nPjwvZz48L2c+PC9zdmc+");

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMi4yOCAyMi43NSI+PGRlZnM+PHN0eWxlPi53b3Jkc2Z1bGwtY2xzLTF7ZmlsbDojN2NlYTM3O30ud29yZHNmdWxsLWNscy0yLC53b3Jkc2Z1bGwtY2xzLTN7ZmlsbDpub25lO30ud29yZHNmdWxsLWNscy0ze3N0cm9rZTojMTQ2MDBlO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS13aWR0aDoycHg7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PGcgaWQ9Ikdyb3VwXzIzNiIgZGF0YS1uYW1lPSJHcm91cCAyMzYiPjxwYXRoIGlkPSJQYXRoXzI1IiBkYXRhLW5hbWU9IlBhdGggMjUiIGNsYXNzPSJ3b3Jkc2Z1bGwtY2xzLTEiIGQ9Ik00LDE1LjEyYzEuNzcuMDcsMTQuMzQsMCwxNC4zNCwwbC0xLjU3LDYuNjNINS41WiIvPjxwYXRoIGlkPSJQYXRoXzI2IiBkYXRhLW5hbWU9IlBhdGggMjYiIGNsYXNzPSJ3b3Jkc2Z1bGwtY2xzLTEiIGQ9Ik0xLjY2LDEuN2MyLjI5LjE3LDE4LjU1LDAsMTguNTUsMEwxOC4xOCwxN0gzLjYzWiIvPjxsaW5lIGlkPSJMaW5lXzE0IiBkYXRhLW5hbWU9IkxpbmUgMTQiIGNsYXNzPSJ3b3Jkc2Z1bGwtY2xzLTIiIHgxPSIzLjU0IiB5MT0iMTEuMiIgeDI9IjE4Ljc5IiB5Mj0iMTEuMiIvPjxsaW5lIGlkPSJMaW5lXzEzIiBkYXRhLW5hbWU9IkxpbmUgMTMiIGNsYXNzPSJ3b3Jkc2Z1bGwtY2xzLTIiIHgxPSIyLjUyIiB5MT0iNS44MSIgeDI9IjE5Ljc0IiB5Mj0iNS44Ii8+PHBhdGggaWQ9IlBhdGhfMjQiIGRhdGEtbmFtZT0iUGF0aCAyNCIgY2xhc3M9IndvcmRzZnVsbC1jbHMtMyIgZD0iTTEuMTYsMWMxLjM2LjA1LDE0LjEzLDAsMTguODIsMGgxLjE1cy0zLDIwLjcxLTUsMjAuNzFINkM0LjEzLDIxLjc1LDEuMTYsMSwxLjE2LDFaIi8+PC9nPjwvZz48L2c+PC9zdmc+");

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMy4wNCAyMy43NSI+PGRlZnM+PHN0eWxlPi5ncmFtbWFyLWNscy0xe2ZpbGw6IzU1NWZmZjtzdHJva2U6IzExOTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBpZD0iUGF0aF8xMTMiIGRhdGEtbmFtZT0iUGF0aCAxMTMiIGNsYXNzPSJncmFtbWFyLWNscy0xIiBkPSJNMzIsMSwxNi40MSw2LjYzSDIuNzFMMSwyMi43NUgxOC4xTDE2LjQxLDYuODkiLz48L2c+PC9nPjwvc3ZnPg==");

/***/ }),

/***/ 284:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOC4yMyAzNS44NSI+PGRlZnM+PHN0eWxlPi5zZW4tY2xzLTF7ZmlsbDojNTU1ZmZmO30uc2VuLWNscy0yLC5zZW4tY2xzLTMsLnNlbi1jbHMtNCwuc2VuLWNscy01e2ZpbGw6bm9uZTt9LnNlbi1jbHMtM3tzdHJva2U6IzU1NWZmZjt9LnNlbi1jbHMtMywuc2VuLWNscy01e3N0cm9rZS13aWR0aDoycHg7fS5zZW4tY2xzLTQsLnNlbi1jbHMtNXtzdHJva2U6IzExOTtzdHJva2UtbGluZWNhcDpyb3VuZDt9LnNlbi1jbHMtNHtzdHJva2Utd2lkdGg6MnB4O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPjxnIGlkPSJHcm91cF8yMzkiIGRhdGEtbmFtZT0iR3JvdXAgMjM5Ij48cGF0aCBpZD0iUGF0aF84NiIgZGF0YS1uYW1lPSJQYXRoIDg2IiBjbGFzcz0ic2VuLWNscy0xIiBkPSJNMTMsMTYuNDhsMTMuNjUtLjYxTDIwLjMsMjMuNzJaIi8+PGcgaWQ9Ikdyb3VwXzE3MyIgZGF0YS1uYW1lPSJHcm91cCAxNzMiPjxwYXRoIGlkPSJQYXRoXzI1IiBkYXRhLW5hbWU9IlBhdGggMjUiIGNsYXNzPSJzZW4tY2xzLTEiIGQ9Ik0yLjg3LDMwLjgyYzEuMDgsMCw4LjcxLDAsOC43MSwwbC0uOTUsNEgzLjhaIi8+PHBhdGggaWQ9IlBhdGhfMjYiIGRhdGEtbmFtZT0iUGF0aCAyNiIgY2xhc3M9InNlbi1jbHMtMSIgZD0iTTIuMTgsMjguNDRjMS4yMywwLDEwLDAsMTAsMEwxMS4wOCwzMkgzLjI0WiIvPjxsaW5lIGlkPSJMaW5lXzE0IiBkYXRhLW5hbWU9IkxpbmUgMTQiIGNsYXNzPSJzZW4tY2xzLTIiIHgxPSIyLjYxIiB5MT0iMjguNDQiIHgyPSIxMS44NyIgeTI9IjI4LjQ0Ii8+PGxpbmUgaWQ9IkxpbmVfMTMiIGRhdGEtbmFtZT0iTGluZSAxMyIgY2xhc3M9InNlbi1jbHMtMiIgeDE9IjEuOTkiIHkxPSIyNS4xNiIgeDI9IjEyLjQ1IiB5Mj0iMjUuMTYiLz48L2c+PHBhdGggaWQ9IlBhdGhfODUiIGRhdGEtbmFtZT0iUGF0aCA4NSIgY2xhc3M9InNlbi1jbHMtMyIgZD0iTTI1LjY2LDE2LjE3bC0xNC44NC4zOS0xLjA4LjY4VjI5LjlMOC4zOCwzMS4zMyIvPjxwYXRoIGlkPSJQYXRoXzg0IiBkYXRhLW5hbWU9IlBhdGggODQiIGNsYXNzPSJzZW4tY2xzLTQiIGQ9Ik0yMi4wNiwxbC0zLjQ4LDkuNDctNS42Niw2LjM3aC4zMmw2LjgzLDcuMDksNi42Ny04TDE5LDEwLjgyIi8+PHBhdGggaWQ9IlBhdGhfODgiIGRhdGEtbmFtZT0iUGF0aCA4OCIgY2xhc3M9InNlbi1jbHMtNSIgZD0iTTEuMTYsMjIuMjdjLjgzLDAsOC41OCwwLDExLjQzLDBoLjdzLTEuODEsMTIuNTgtMywxMi41OEg0LjFDMywzNC44NSwxLjE2LDIyLjI3LDEuMTYsMjIuMjdaIi8+PC9nPjwvZz48L2c+PC9zdmc+");

/***/ }),

/***/ 285:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    lessonMaterials: null
  },
  mutations: {
    setLessonMaterials: function setLessonMaterials(state, payload) {
      state.lessonMaterials = payload;
    }
  },
  actions: {
    getLessonMaterials: function getLessonMaterials(_ref) {
      var commit = _ref.commit;
      var _getters$user$courseV = this.getters.user.courseViewLocation,
          chapter = _getters$user$courseV.chapter,
          lesson = _getters$user$courseV.lesson;

      commit("setLoading", true);

      if (this.getters.lessonMaterialsData && this.getters.lessonMaterialsData.length > 0) {
        commit("setLessonMaterials", this.getters.lessonMaterialsData);
        return commit("setLoading", false);
      }
      var URL = "https://us-central1-meduberet-project.cloudfunctions.net/fetchLessonMaterials?chapter=" + chapter + "&lesson=" + lesson;
      __WEBPACK_IMPORTED_MODULE_0_axios___default()({
        method: "get",
        url: URL,
        headers: {
          "Content-Type": "text/plain"
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        commit("setLessonMaterials", data.materials);
        commit("setLoading", false);
      }).catch(function (err) {
        console.error(err);
        return null;
      });
    }
  },
  getters: {
    lessonMaterials: function lessonMaterials(state) {
      return state.lessonMaterials;
    }
  }
});

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(287);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("13cbb262", content, true, {});

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, "\n.backarrowDiv[data-v-486302e7] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 50px;\n  height: 50px;\n}\n.arrow-svg-lesson[data-v-486302e7] {\n  margin: auto;\n}\n.noShow[data-v-486302e7] {\n  opacity: 0;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Lesson/lesson-header.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,aAAa;CACd;AACD;EACE,aAAa;CACd;AACD;EACE,WAAW;CACZ","file":"lesson-header.vue","sourcesContent":["\n.backarrowDiv[data-v-486302e7] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 50px;\n  height: 50px;\n}\n.arrow-svg-lesson[data-v-486302e7] {\n  margin: auto;\n}\n.noShow[data-v-486302e7] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lesson_header_scss__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lesson_header_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lesson_header_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_svgConfig__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__(78);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "lesson-header",
  props: ["currentData", "outerData", "externalType"],
  data: function data() {
    return {
      lessonName: "",
      arrowIconPath: {
        arrowIconNext: "",
        arrowIconPrevious: ""
      }
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.arrowIconPath = Object(__WEBPACK_IMPORTED_MODULE_3__utils_svgConfig__["a" /* getArrowIconPath */])(localStorage.getItem("srcDirection"));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    currentData: function currentData() {
      this.lessonName = this.currentData ? this.currentData.name : "";
    }
  },
  mounted: function mounted() {
    this.lessonName = this.currentData ? this.currentData.name : "";
  },

  methods: {
    prevChapter: function prevChapter(event) {
      console.log("VLIVK");
      if (this.externalType === "grammar" || this.externalType === "sentence") this.$emit("closeIntro", "ok");

      if (!this.externalType) this.$router.push({
        path: "/chapter/"
      });
    }
  },
  components: {}
});

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(290);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("656b7fdf", content, true, {});

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".lesson-header{display:grid;justify-content:space-between;background-color:var(--header-primary);height:60px;grid-template-columns:15% 1fr 15%;align-items:center;justify-items:center}.lesson-header h2{text-align:center;font:var(--medium-font)}.lesson-header h6{text-align:center;font:var(--medium-font);color:var(--button-primary-text)}.lesson-titles{display:flex;flex-direction:column;align-items:center;justify-content:space-between}.cup-svg{width:35px;height:35px}.arrow-svg-lesson{height:30px;aspect-ratio:1/1;fill:var(--button-primary-text)}.disabled{fill:var(--color-disabled)}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Lesson/src/components/Lesson/lesson-header.scss"],"names":[],"mappings":"AAEA,eACE,aACA,8BACA,uCACA,YACA,kCACA,mBACA,oBAAA,CAEA,kBACE,kBACA,uBAAA,CAEF,kBACE,kBACA,wBACA,gCAAA,CAIJ,eACE,aACA,sBACA,mBACA,6BAAA,CAGF,SACE,WACA,WAAA,CAEF,kBACE,YACA,iBACA,+BAAA,CAGF,UACE,0BAAA,CAAA","file":"lesson-header.scss","sourcesContent":["@import \"../../scss//abstracts/variables\";\n\n.lesson-header {\n  display: grid;\n  justify-content: space-between;\n  background-color: var(--header-primary);\n  height: 60px;\n  grid-template-columns: 15% 1fr 15%;\n  align-items: center;\n  justify-items: center;\n\n  h2 {\n    text-align: center;\n    font: var(--medium-font);\n  }\n  h6 {\n    text-align: center;\n    font: var(--medium-font);\n    color: var(--button-primary-text);\n  }\n}\n\n.lesson-titles {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.cup-svg {\n  width: 35px;\n  height: 35px;\n}\n.arrow-svg-lesson {\n  height: 30px;\n  aspect-ratio: 1/1;\n  fill: var(--button-primary-text);\n}\n\n.disabled {\n  fill: var(--color-disabled);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lesson-header"
  }, [_c('div', {
    staticClass: "backarrowDiv",
    on: {
      "click": _vm.prevChapter
    }
  }, [_c('inline-svg', {
    staticClass: "arrow-svg-lesson",
    attrs: {
      "src": _vm.arrowIconPath.arrowIconPrevious
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "lesson-titles"
  }, [(_vm.currentData) ? _c('h2', [_vm._v("\n      " + _vm._s(_vm.currentData.courseName) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.currentData) ? _c('h6', [_vm._v("\n      " + _vm._s(_vm.lessonName ? _vm.lessonName : "") + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.outerData) ? _c('h6', [_vm._v("\n      " + _vm._s(_vm.outerData ? _vm.outerData : "") + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('inline-svg', {
    staticClass: "cup-svg",
    class: {
      noShow: _vm.outerData
    },
    attrs: {
      "src": __webpack_require__(237).default
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__external_game_scss__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__external_game_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__external_game_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_svg_arrow_left_svg__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_svg_lesson_svg__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_svg_wordshalf_svg__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_svg_wordsfull_svg__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_svg_grammar_svg__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_svg_sentences_svg__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_course__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_VideoPlayer_vue__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Shared_VideoPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Shared_VideoPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_courseService__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_userService__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__onBoardingModal_OnBoardingModal_vue__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__onBoardingModal_OnBoardingModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__onBoardingModal_OnBoardingModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lesson_header_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lesson_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__lesson_header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Shared_Slinky_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Shared_Slinky_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Shared_Slinky_vue__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Externals",
  props: ["exType", "permission"],
  data: function data() {
    return {
      external: null,
      chapter: null,
      choose: null,
      sounds: false,
      type: null,
      pickedType: "",
      id: null,
      game: null,
      loading: false,
      intro: false,
      intro_video: null,
      intro_audio: null,
      intro_image: null,
      intro_text: null,
      introClose: null,
      Arrow: __WEBPACK_IMPORTED_MODULE_4__assets_svg_arrow_left_svg__["default"],
      imgTypes: {
        lesson: __WEBPACK_IMPORTED_MODULE_5__assets_svg_lesson_svg__["default"],
        wordshalf: __WEBPACK_IMPORTED_MODULE_6__assets_svg_wordshalf_svg__["a" /* default */],
        wordsfull: __WEBPACK_IMPORTED_MODULE_7__assets_svg_wordsfull_svg__["a" /* default */],
        grammar: __WEBPACK_IMPORTED_MODULE_8__assets_svg_grammar_svg__["a" /* default */],
        sentences: __WEBPACK_IMPORTED_MODULE_9__assets_svg_sentences_svg__["a" /* default */]
      },
      types: {
        lesson: this.$t("lesson.external-game.lesson"),
        wordshalf: this.$t("lesson.external-game.wordshalf"),
        wordsfull: this.$t("lesson.external-game.wordsfull"),
        sentences: this.$t("lesson.external-game.sentences"),
        grammar: this.$t("lesson.external-game.grammar")
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log(_this.exType);
              if (_this.exType) {
                _this.type = _this.exType;
              } else if (_this.$route.query.type) {
                _this.type = _this.$route.query.type;
              }
              if (_this.type) {
                _this.external = _this.filterExternals(_this.type);
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    userGames: function userGames() {
      if (this.user) {
        var games = this.user.games.filter(function (game) {
          return game.is_done;
        }).map(function (game) {
          return game.game.id;
        });
        return games;
      }
      return [];
    },
    externals: function externals() {
      return this.$store.getters.externals;
    },
    safeTopVar: function safeTopVar() {
      return { "--top": this.$store.getters.safeTop + "px" };
    }
  },
  methods: {
    clicked: function clicked(event) {
      console.log("closed intro", event);
      this.$emit("showFooter");
      this.introClose = true;
      if (this.game) this.playGame(this.game);
    },
    goPay: function goPay() {
      this.$router.push({
        path: "/registration"
      });
    },
    filterExternals: function filterExternals(gameType) {
      return this.externals.map(function (res) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, res, {
          games: res.games.filter(function (res) {
            return res.game_type == gameType;
          })
        });
      }).filter(function (section) {
        return section.games.length;
      });
    },
    checkPermission: function checkPermission(game, userPermission) {
      if (game.permission === "unknown" || userPermission === "paying") return true;else if (game.permission === userPermission) return true;else return false;
    },
    calculateHeight: function calculateHeight(type) {
      return this.pickedType === type ? type.games.length * 60 + 70 + "px" : "54px";
    },
    pickType: function pickType(type) {
      if (this.pickedType === type) {
        this.pickedType = "";
        return;
      }
      this.pickedType = type;
    },
    goBack: function goBack() {
      this.$emit("showFooter");
      this.playUrl = null;
      this.intro = false;
      this.introClose = true;
      // this.$router.push({
      //   path: `/external-${this.exType}`
      // });
    },
    getGame: function getGame(game) {
      this.game = game;
      this.id = game.id;
      if (this.loading == true) return;
      if (game.intro_video || game.intro_text || game.intro_image || game.intro_audio) {
        this.intro_video = game.intro_video;
        this.intro_text = game.intro_text;
        this.intro_image = game.intro_image;
        this.intro_audio = game.intro_audio;
        if (game && this.checkPermission(game, this.permission)) {
          this.loading = true;
          this.intro = true;
          this.introClose = false;
          this.$emit("hideFooter");
          this.loading = false;
        } else {
          if (game && game.permission == "paying") this.goPay();
        }
        console.log("INTRO");
      } else {
        this.introClose = true;
        console.log("NO INTRO");
        this.playGame(game);
      }
    },
    closeIntro: function closeIntro() {
      this.playUrl = null;
      this.$emit("showFooter");
      this.intro = false;
      this.introClose = true;
      console.log("EMITTED");
    },
    playGame: function playGame(game) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(game && _this2.checkPermission(game, _this2.permission))) {
                  _context2.next = 9;
                  break;
                }

                if (!_this2.user) {
                  _context2.next = 6;
                  break;
                }

                _this2.loading = true;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_13__services_userService__["a" /* userService */].startGame(game.id);

              case 5:
                _this2.loading = false;

              case 6:
                _this2.$router.push({
                  path: "/" + game.game_type + "/" + game.algolia_game_id + "/?id=" + game.id + "&name=" + game.name
                });
                _context2.next = 11;
                break;

              case 9:
                console.log("a", game.permission);
                if (game.permission == "paying") _this2.goPay();

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },

    goTo: function goTo(lesson) {
      // this.$store.commit({
      //   type: "setCurrentGame",
      //   lesson,
      //   courseId: course.order,
      //   courseName: course.name
      // });
      // this.$router.push({
      //   path: `../play/${lesson.type}/${lesson.game_id}`
      // });
      console.log("OK");
    }
  },
  watch: {
    type: function type() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.external = _this3.filterExternals(_this3.type);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    exType: function exType() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.type = _this4.exType;

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    externals: function externals() {
      this.external = this.filterExternals(this.type);
    }
  },
  components: { OnBoardingModal: __WEBPACK_IMPORTED_MODULE_14__onBoardingModal_OnBoardingModal_vue___default.a, LessonHeader: __WEBPACK_IMPORTED_MODULE_15__lesson_header_vue___default.a, SlinkyVue: __WEBPACK_IMPORTED_MODULE_16__Shared_Slinky_vue___default.a }
});

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(317);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(177)("82a41bc2", content, true, {});

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(176)(true);
// imports


// module
exports.push([module.i, ".loader{text-align:center;margin:30px}.lesson-type{height:49px;display:flex;font-size:var(--large-font);justify-content:space-between;align-items:center;border-bottom:1px solid var(--bubble-stroke)}.lesson-type:not(:first-child){border-top:1px solid var(--bubble-stroke)}.collapsed{transition:all .3s;overflow-y:hidden}.collapsed:last-child{margin-bottom:125px}.check-v-ex{z-index:4;position:absolute;top:50%;left:50%;transform:translate(-40%, -50%) scale(1.1)}.lesson-wrapper{padding:16px 16px 0 16px;display:flex;flex-direction:column}.down-arrow{transition:transform .5s}.upside-arrow{transition:transform .5s;transform:rotate(180deg)}.arrow{display:flex;margin-left:8px}.player{text-align:center}.done{border:1px solid var(--color-primary);color:var(--button-primary-text);background-color:var(--button-primary);padding:5px 10px;border-radius:10px;margin:10px}.lesson-icon{position:absolute;margin:0}.lockSign{position:relative;border-radius:100%;width:35px;height:20px;padding:3px}.videoPlayer1{height:250px}.check-svg{width:20px;height:20px;fill:var(--game-button-primary)}.chapter-course{height:calc(100vh - 130px);overflow:auto;font:var(--medium-font)}.gameText{font:var(--medium-font)}.disbaledText{color:var(--color-disabled)}.step{height:44px;padding:13px;display:flex;flex-direction:row;justify-content:flex-start;margin:8px 0;border-radius:100px;box-shadow:0 0 4px 2px var(--header-secondary-lt);align-items:center}.v-stepper-course{position:relative;height:fit-content}.step .circle{background-color:var(--bg-primary);border:2px solid var(--bubble-stroke);border-radius:100%;width:18px;aspect-ratio:1/1;display:inline-block}.step .line{top:20px;left:8.5px;height:100%;position:absolute;border-right:3px solid var(--game-button-stroke)}.step.completed .circle{visibility:visible;border-color:var(--success-stroke) !important;background:var(--bg-primary) !important}.step.completed .circle+svg{opacity:0}.step.completed .line{border-right:3px solid #0696d7}.step.active .circle{visibility:visible;border-color:var(--button-primary)}.step.empty .circle{border-color:var(--bg-primary)}.step.empty .line{top:0;height:150%}.gameContent{margin-inline-start:8px}.backBtnModal{z-index:100;position:relative;background-color:var(--bg-primary);text-align:center;width:100%}.back-svg{width:35px}.modal{padding-bottom:58px;background-color:var(--bg-primary)}.lessonOnTop{position:fixed;top:var(--top);z-index:999999;width:100%}.goto-video-button{border:2px solid var(--button-primary);color:var(--button-primary);padding:4px;border-radius:8px;min-height:60px;font:var(--medium-font);margin:48px auto;width:90vw;display:block}@media(min-width: 780px){.lessonOnTop{width:60%}}", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Lesson/src/components/Lesson/external-game.scss"],"names":[],"mappings":"AAKA,QACE,kBACA,WAAA,CAGF,aACE,YACA,aACA,4BACA,8BACA,mBACA,4CAAA,CAGF,+BACE,yCAAA,CAGF,WACE,mBACA,iBAAA,CAGF,sBACE,mBAAA,CAGF,YACE,UACA,kBACA,QACA,SACA,0CAAA,CAGF,gBACE,yBACA,aACA,qBAAA,CAGF,YACE,wBAAA,CAGF,cACE,yBACA,wBAAA,CAGF,OACE,aACA,eAAA,CAGF,QACE,iBAAA,CAGF,MACE,sCACA,iCACA,uCACA,iBACA,mBACA,WAAA,CAGF,aACE,kBACA,QAAA,CAGF,UACE,kBACA,mBACA,WACA,YACA,WAAA,CAGF,cACE,YAAA,CAGF,WACE,WACA,YACA,+BAAA,CAGF,gBACE,2BAEA,cACA,uBAAA,CAGF,UACE,uBAAA,CAGF,cACE,2BAAA,CAWF,MACE,YACA,aACA,aACA,mBACA,2BACA,aACA,oBACA,kDACA,kBAAA,CAGF,kBACE,kBACA,kBAAA,CAKF,cACE,mCACA,sCACA,mBACA,WACA,iBACA,oBAAA,CAGF,YACE,SACA,WAEA,YAEA,kBACA,gDAAA,CAGF,wBACE,mBAEA,8CACA,uCAAA,CAGF,4BACE,SAAA,CAGF,sBACE,8BAAA,CAGF,qBACE,mBACA,kCAAA,CAGF,oBAEE,8BAAA,CAGF,kBAGE,MACA,WAAA,CAGF,aACE,uBAAA,CAGF,cACE,YACA,kBACA,mCACA,kBAEA,UAAA,CAGF,UACE,UAAA,CAGF,OACE,oBACA,kCAAA,CAGF,aACE,eACA,eACA,eACA,UAAA,CAGF,mBACE,uCACA,4BACA,YACA,kBACA,gBACA,wBACA,iBACA,WACA,aAAA,CAGF,yBACE,aACE,SAAA,CAAA,CAAA","file":"external-game.scss","sourcesContent":["@import \"../../scss//abstracts/variables\";\n\n$step-border-size: 2px;\n$step-shadow-size: 2px;\n\n.loader {\n  text-align: center;\n  margin: 30px;\n}\n\n.lesson-type {\n  height: 49px;\n  display: flex;\n  font-size: var(--large-font);\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid var(--bubble-stroke);\n}\n\n.lesson-type:not(:first-child) {\n  border-top: 1px solid var(--bubble-stroke);\n}\n\n.collapsed {\n  transition: all 0.3s;\n  overflow-y: hidden;\n}\n\n.collapsed:last-child {\n  margin-bottom: 125px;\n}\n\n.check-v-ex {\n  z-index: 4;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-40%, -50%) scale(1.1);\n}\n\n.lesson-wrapper {\n  padding: 16px 16px 0 16px;\n  display: flex;\n  flex-direction: column;\n}\n\n.down-arrow {\n  transition: transform 0.5s;\n}\n\n.upside-arrow {\n  transition: transform 0.5s;\n  transform: rotate(180deg);\n}\n\n.arrow {\n  display: flex;\n  margin-left: 8px;\n}\n\n.player {\n  text-align: center;\n}\n\n.done {\n  border: 1px solid var(--color-primary);\n  color: var(--button-primary-text);\n  background-color: var(--button-primary);\n  padding: 5px 10px;\n  border-radius: 10px;\n  margin: 10px;\n}\n\n.lesson-icon {\n  position: absolute;\n  margin: 0;\n}\n\n.lockSign {\n  position: relative;\n  border-radius: 100%;\n  width: 35px;\n  height: 20px;\n  padding: 3px;\n}\n\n.videoPlayer1 {\n  height: 250px;\n}\n\n.check-svg {\n  width: 20px;\n  height: 20px;\n  fill: var(--game-button-primary);\n}\n\n.chapter-course {\n  height: calc(100vh - 130px);\n\n  overflow: auto;\n  font: var(--medium-font);\n}\n\n.gameText {\n  font: var(--medium-font);\n}\n\n.disbaledText {\n  color: var(--color-disabled);\n}\n\n// .inner-circle {\n//   width: 10px;\n//   height: 10px;\n//   border-radius: 50%;\n//   background-color: #111199;\n//   margin: 2px auto;\n// }\n\n.step {\n  height: 44px;\n  padding: 13px;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  margin: 8px 0;\n  border-radius: 100px;\n  box-shadow: 0 0 4px 2px var(--header-secondary-lt);\n  align-items: center;\n}\n\n.v-stepper-course {\n  position: relative;\n  height: fit-content;\n  /*   visibility: visible; */\n}\n\n/* regular step */\n.step .circle {\n  background-color: var(--bg-primary);\n  border: 2px solid var(--bubble-stroke);\n  border-radius: 100%;\n  width: 18px;\n  aspect-ratio: 1/1;\n  display: inline-block;\n}\n\n.step .line {\n  top: 20px;\n  left: 8.5px;\n  /*   height: 120px; */\n  height: 100%;\n\n  position: absolute;\n  border-right: 3px solid var(--game-button-stroke);\n}\n\n.step.completed .circle {\n  visibility: visible;\n  /* background-color: rgb(6, 150, 215); */\n  border-color: var(--success-stroke) !important;\n  background: var(--bg-primary) !important;\n}\n\n.step.completed .circle + svg {\n  opacity: 0;\n}\n\n.step.completed .line {\n  border-right: 3px solid rgb(6, 150, 215);\n}\n\n.step.active .circle {\n  visibility: visible;\n  border-color: var(--button-primary);\n}\n\n.step.empty .circle {\n  //visibility: hidden;\n  border-color: var(--bg-primary);\n}\n\n.step.empty .line {\n  /*     visibility: hidden; */\n  /*   height: 150%; */\n  top: 0;\n  height: 150%;\n}\n\n.gameContent {\n  margin-inline-start: 8px;\n}\n\n.backBtnModal {\n  z-index: 100;\n  position: relative;\n  background-color: var(--bg-primary);\n  text-align: center;\n\n  width: 100%;\n}\n\n.back-svg {\n  width: 35px;\n}\n\n.modal {\n  padding-bottom: 58px;\n  background-color: var(--bg-primary);\n}\n\n.lessonOnTop {\n  position: fixed;\n  top: var(--top);\n  z-index: 999999;\n  width: 100%;\n}\n\n.goto-video-button {\n  border: 2px solid var(--button-primary);\n  color: var(--button-primary);\n  padding: 4px;\n  border-radius: 8px;\n  min-height: 60px;\n  font: var(--medium-font);\n  margin: 48px auto;\n  width: 90vw;\n  display: block;\n}\n\n@media (min-width: 780px) {\n  .lessonOnTop {\n    width: 60%;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-chapter"
  }, [(!_vm.external || _vm.external.length === 0) ? _c('div', {
    staticClass: "loader"
  }, [_vm._v("\n    " + _vm._s(_vm.$t("lesson.external-game.loading")) + "\n    "), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "center",
      "margin": "8px"
    }
  }, [_c('SlinkyVue')], 1)]) : _vm._e(), _vm._v(" "), (_vm.intro) ? _c('LessonHeader', {
    staticClass: "lessonOnTop",
    style: (_vm.safeTopVar),
    attrs: {
      "outerData": _vm.game.name,
      "externalType": _vm.game.game_type
    },
    on: {
      "closeIntro": _vm.closeIntro
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n\n    " + _vm._s(_vm.$t("lesson.external-game.loading-game")) + "\n    "), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "justify-content": "center",
      "margin": "8px"
    }
  }, [_c('SlinkyVue')], 1)]) : _vm._e(), _vm._v(" "), (_vm.intro) ? _c('OnBoardingModal', {
    attrs: {
      "type": "game",
      "text": _vm.intro_text,
      "audioSrc": _vm.intro_audio,
      "imgSrc": _vm.intro_image,
      "vidSrc": _vm.intro_video,
      "id": _vm.id
    },
    on: {
      "clicked": _vm.clicked
    }
  }) : (_vm.external) ? _c('div', {
    staticClass: "chapter-course"
  }, _vm._l((_vm.external), function(section) {
    return _c('div', {
      key: section.name,
      staticClass: "collapsed",
      style: ({
        height: _vm.calculateHeight(section)
      })
    }, [_c('div', {
      staticClass: "lesson-type",
      on: {
        "click": function($event) {
          return _vm.pickType(section)
        }
      }
    }, [_c('div', [_c('div', [_c('h5', [_vm._v(_vm._s(section["name"]))])])]), _vm._v(" "), _c('div', {
      staticClass: "arrow"
    }, [_c('inline-svg', {
      class: _vm.pickedType == section ? 'upside-arrow' : 'down-arrow',
      attrs: {
        "src": __webpack_require__(227).default
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "lesson-wrapper"
    }, _vm._l((section.games), function(game) {
      return _c('div', {
        key: game.id,
        staticClass: "step",
        class: {
          completed: _vm.userGames.includes(game.id)
        },
        on: {
          "click": function($event) {
            return _vm.getGame(game)
          }
        }
      }, [_c('div', {
        staticClass: "v-stepper-course"
      }, [_c('div', {
        staticClass: "circle"
      }, [(_vm.userGames.includes(game.id)) ? _c('inline-svg', {
        staticClass: "check-v-ex",
        attrs: {
          "src": __webpack_require__(280).default
        }
      }) : _vm._e()], 1), _vm._v(" "), (
        game.permission !== 'unknown' &&
        game.permission !== _vm.permission &&
        _vm.permission !== 'paying'
      ) ? _c('div', {
        staticClass: "lesson-icon"
      }, [(
        game &&
        game.permission !== 'unknown' &&
        game.permission !== _vm.permission &&
        _vm.permission !== 'paying'
      ) ? _c('inline-svg', {
        staticClass: "lockSign",
        attrs: {
          "width": "14px",
          "height": "14px",
          "src": __webpack_require__(249).default
        }
      }) : _vm._e(), _vm._v(" "), (
        game &&
        game.permission !== 'unknown' &&
        game.permission !== _vm.permission &&
        _vm.permission !== 'paying' &&
        game.permission == 'registered'
      ) ? _c('inline-svg', {
        attrs: {
          "width": "14px",
          "height": "14px",
          "src": __webpack_require__(212).default
        }
      }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "gameText",
        class: {
          gameContent: true,
          disbaledText: game.permission !== 'unknown' &&
            game.permission !== _vm.permission &&
            _vm.permission !== 'paying'
        }
      }, [_vm._v("\n            " + _vm._s(game.name) + "\n          ")])])
    }), 0)])
  }), 0) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// 7.ce03fd3d81a126f24b18.bundle.js